import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import classNames from "classnames";
import {Field, getFormValues} from "redux-form";
import Grid from "@material-ui/core/Grid";
import RadioField from "../RadioField";

import whom from "../../mocks/whom";

import styles from "./question.module.scss";

function SecondQuestion(props) {
  const {
    values: {gender}
  } = props;
  const options = whom[gender];
  return (
    <Grid container>
      <Grid item md={5} xs={12}>
        <div className={classNames(styles.icon, styles.whomIcon)}></div>
      </Grid>
      <Grid item md={7} xs={12}>
        <h3 className={styles.title}>Кому дарить</h3>
        <Grid container className={styles.content}>
          {options.map(({value, label}) => (
            <Grid key={value} item xs={6}>
              <Field
                name="whom"
                component={RadioField}
                type="radio"
                value={value}
                label={label}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}

SecondQuestion.propTypes = {
  values: PropTypes.object
};

export default connect((state) => ({
  values: getFormValues(`quiz`)(state)
}))(SecondQuestion);
